import { Modifiers } from "@mui/material";
import { HeatConfig } from "graphql/generated/types";

export type Modifier =
    | "PriorityInterference"
    | "Interference"
    | "DNS"
    | "DNF"
    | "DSQ"
    | "DNI"
    | "Double"
    | "AbbPenalty";

export type ModifierConfig = {
    name: string;
    label: string;
    variant: keyof Modifiers;
};

export const modifierToModifierConfig: Record<Modifier, ModifierConfig> = {
    PriorityInterference: {
        name: "Priority Interference",
        label: "P.INT",
        variant: "priorityInterference",
    },
    Interference: {
        name: "Interference",
        label: "INT",
        variant: "interference",
    },
    DNS: {
        name: "Did Not Start",
        label: "DNS",
        variant: "dns",
    },
    DNF: {
        name: "Did Not Finish",
        label: "DNF",
        variant: "dnf",
    },
    DSQ: {
        name: "Disqualified",
        label: "DSQ",
        variant: "dsq",
    },
    DNI: {
        name: "Did Not Improve",
        label: "DNI",
        variant: "dni",
    },
    Double: {
        name: "Double Whammy",
        label: "DW",
        variant: "double",
    },
    AbbPenalty: {
        name: "Team 5 Point Penalty",
        label: "TP",
        variant: "abbPenalty",
    },
};

export const getModifierFromModifierType = (
    modifierType: unknown,
): Modifier | undefined => {
    if (typeof modifierType !== "string") {
        return undefined;
    }

    const modifier = modifierType.replace(/^Modifiers::/, "");

    return isModifier(modifier) ? modifier : undefined;
};

export const isModifier = (modifier: unknown): modifier is Modifier => {
    return (
        typeof modifier === "string" &&
        modifierToModifierConfig.hasOwnProperty(modifier)
    );
};

export const getModifiers = (modifiers: HeatConfig["modifiers"]): Modifier[] =>
    modifiers.filter(isModifier);

export const getModifierName = (modifier: Modifier) =>
    modifierToModifierConfig[modifier].name;

export const getModifierLabel = (modifier: Modifier) =>
    modifierToModifierConfig[modifier].label;

export const getModifierVariant = (modifier: Modifier) =>
    modifierToModifierConfig[modifier].variant;

export const MODIFIERS_PREFIX = "Modifiers::";

export const selected = (
    selectedModifier: Modifier,
    modifierOption: Modifier,
): boolean => selectedModifier === `${MODIFIERS_PREFIX}${modifierOption}`;
